import { HStack, VStack } from '@chakra-ui/react';

import { useCurrentUser } from 'auth/CurrentUserProvider';
import BigTokens from 'components/BigTokens';
import SettingsTile from 'components/Billing/SettingsTile';
import { LinkInput } from 'components/LinkInput';
import { REFERRAL_EMAIL_SUBJECT, REFERRAL_SHARE_TEXT } from 'components/Modal/InviteModal';
import ShareButtons from 'components/ShareButtons';
import Text from 'components/Text';
import { useMediaQueries } from 'layout/MediaQueriesProvider';
import { CreditReward } from 'utils/constants';
import { referralBuilder } from 'utils/strings';

export const ReferralLinkSettings = () => {
  const { hasExhaustedReferralLink, referralCode } = useCurrentUser();
  const { isSmallScreen } = useMediaQueries();

  const referralLink = referralBuilder(referralCode);

  return (
    <>
      <SettingsTile
        title="Referral link"
        subtitle={
          hasExhaustedReferralLink ? (
            'Invite friends to BigDevSoon with your own referral link.'
          ) : (
            <HStack spacing={1}>
              <Text opacity="secondary" fontWeight="regular">
                Collect
              </Text>
              <BigTokens amount={CreditReward.Referral} />
              <Text fontSize="small">BigToken</Text>
              {!isSmallScreen && (
                <Text opacity="secondary" fontWeight="regular">
                  for each registration.
                </Text>
              )}
              <Text fontWeight="regular" opacity="secondary" fontSize="micro">
                (up to 5)
              </Text>
            </HStack>
          )
        }
      >
        <VStack spacing={4} w="100%" align="flex-start">
          <LinkInput />
          <Text fontSize="small" opacity="secondary" fontWeight="semibold">
            Share via
          </Text>
          <ShareButtons
            text={REFERRAL_SHARE_TEXT}
            link={referralLink}
            emailSubject={REFERRAL_EMAIL_SUBJECT}
          />
        </VStack>
      </SettingsTile>
    </>
  );
};
